module.exports = __webpack_public_path__ + "img/jamb.2ba15fe8.png";